<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
                :showBtn="false"
                title="VDS Certificate"
            />
        </div>
        <div class="px-2 pt-2">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <button
                        class="nav-link"
                        :class="{ active: activeTab === 'pending' }"
                        @click="switchTab('pending')"
                        type="button"
                    >Pending</button>
                </li>
                <li class="nav-item">
                    <button
                        class="nav-link"
                        :class="{ active: activeTab === 'issued' }"
                        @click="switchTab('issued')"
                        type="button"
                    >Certificate Issued</button>
                </li>
            </ul>
        </div>

        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="mushak-six-query-setter"
            >
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1">
                    <div class="d-flex align-items-center justify-content-between filter-label">
                        <label for="colFormLabel" class="col-form-label">Party: </label>
                        <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>

                    <AsyncSelect
                        placeholder="Select Party"
                        v-model="singleContact"
                        :api-service="fetchContactProfiles"
                        :format-label="formatPatientLabel"
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1">
                    <label for="colFormLabel" class="col-form-label">Accounting Head</label>
                    <v-select
                        v-model="params.account_head_id"
                        :options="accountHeads"
                        label="name"
                        :reduce="(item) => item.id"
                        placeholder="Select head"
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-1">
                    <label for="colFormLabel" class="col-form-label">VDS Section Head</label>
                    <v-select
                        v-model="params.vds_rate_id"
                        placeholder="Select VDS Section Head"
                        :options="vdsRateList"
                        :reduce="item => item.id"
                        label="name"
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-1">
                    <label for="colFormLabel" class="col-form-label">Payment Status</label>
                    <v-select
                        v-model="params.payment_status"
                        placeholder="Select Payment Status"
                        :options="paymentStatuses"
                        :reduce="item => item.value"
                        label="name"
                    />
                </div>
            </DateQuerySetter>
        </div>

        <div class="d-flex justify-content-end px-2 mb-2">
            <button
                v-if="isPendingTab && hasSelection"
                @click="onOpenGenerateModal"
                class="btn btn-primary waves-effect waves-float waves-light"
            >
                Generate Certificate ({{ selectedCount }})
            </button>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
            <div class="card card-height">
                <div class="mushak-table-wrap">
                    <table class="table custom-table-padding table-bordered">
                        <thead>
                            <tr>
                                <th v-if="isPendingTab" class="text-center">
                                    <input
                                        type="checkbox"
                                        :checked="isAllSelected"
                                        @change="toggleSelectAll"
                                    >
                                </th>
                                <th>Purchase Bill No</th>
                                <th>Bill Date</th>
                                <th>Bill Ref No</th>
                                <th>Bill Ref Date</th>
                                <th>Supplier Name</th>
                                <th class="text-center">Base Amount</th>
                                <th class="text-center">VAT Amount</th>
                                <th class="text-center">VDS Amount</th>
                                <th class="text-center">Total Amount</th>
                                <th v-if="isIssuedTab">Certificate Number</th>
                                <th v-if="isIssuedTab">Issued Date</th>
                                <th v-if="isIssuedTab" class="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in tableItems" :key="rowKey(item)">
                                <td v-if="isPendingTab" class="text-center">
                                    <input
                                        type="checkbox"
                                        :checked="isSelected(item)"
                                        :disabled="hasCertificate(item)"
                                        @change="toggleSelect(item)"
                                    >
                                </td>
                                <td>{{ item.bill_number }}</td>
                                <td>{{ item.bill_date }}</td>
                                <td>{{ item.bill_referance_no }}</td>
                                <td>{{ item.bill_referance_date }}</td>
                                <td>{{ item.party_name }}</td>
                                <td class="text-right">{{ commaFormat(item.base_amount) }}</td>
                                <td class="text-right">{{ commaFormat(item.vat_amount) }}</td>
                                <td class="text-right">{{ commaFormat(item.vds_amount) }}</td>
                                <td class="text-right">{{ commaFormat(item.bill_amount) }}</td>
                                <td v-if="isIssuedTab">{{ item.certificate_number }}</td>
                                <td v-if="isIssuedTab">{{ item.certificate_date }}</td>
                                <td v-if="isIssuedTab" class="text-center">
                                    <div class="dropdown" v-if="hasCertificate(item)">
                                        <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-boundary="viewport">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end">
                                            <li>
                                                <a class="dropdown-item" href="#" @click.prevent="onEditCertificate(item)">
                                                    <i class="fas fa-eye me-2"></i> View
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="#" @click.prevent="onPrintCertificate(item)">
                                                    <i class="fas fa-print me-2"></i> Print
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="#" @click.prevent="onExportCertificate(item)">
                                                    <i class="fas fa-file-excel me-2"></i> Export
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
                </div>
            </div>
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>

        <ContactDropdownFilter
            v-if="store.state.isModalOpenThree"
            @onSearchContact="onSearchContact"
            :isFilterable="true"
            :companyRoles="companyRoles"
        />

        <GenerateTaxCertificateModal
            ref="generateModal"
            :formData="certificateForm"
            @onSubmit="onSubmitGenerate"
        />

        <EditTaxCertificateModal
            ref="editModal"
            :formData="editForm"
            :certificate="editCertificate"
            :bills="editBills"
            @onSubmit="onSubmitEdit"
            @onDelete="onDeleteFromModal"
        />
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { computed, inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleCompliance from '@/services/modules/compliance/compliance';
import handleReport from "@/services/modules/accountingReport";
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import GenerateTaxCertificateModal from '@/components/molecule/company/compliance/mushak-six-point-six/GenerateTaxCertificateModal.vue';
import EditTaxCertificateModal from '@/components/molecule/company/compliance/mushak-six-point-six/EditTaxCertificateModal.vue';
import handleRole from "@/services/modules/role";
import handleContact from "@/services/modules/contact";
import handleTdsVds from '@/services/modules/procurement/tdsVds'
import handlePurchaseAndSales from "@/services/modules/purchase";
import handleCompany from "@/services/modules/company";
import figureFormatter from '@/services/utils/figureFormatter';
import { resetPaginationPage } from '@/services/utils/global';
import printMushak66 from '@/services/utils/pdf/mushak66Pdf';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const token = computed(() => localStorage.getItem('token'));
const loading = ref(false)
const validTabs = ['pending', 'issued'];
const initialTab = validTabs.includes(route.query.tab) ? route.query.tab : 'pending';
const activeTab = ref(initialTab);
const accountHeads = ref([]);
const companyRoles = ref([]);
const tableItems = ref([]);
const params = ref({
    offset: 20,
    vds_rate_id: null,
    payment_status: null,
    account_head_id: null
});
const vdsRateList = ref([]);
const paymentStatuses = ref([]);
const singleContact = ref(null);
const selectedRows = ref([]);
const generateModal = ref(null);
const certificateForm = ref({
    date: ''
});
const editModal = ref(null);
const editForm = ref({
    date: ''
});
const editCertificate = ref({});
const editBills = ref([]);
const editCertificateId = ref(null);

const { commaFormat } = figureFormatter();
const { fetchMushakSixPointSix, generateTaxCertificate, deleteTaxCertificate, fetchTaxCertificate, updateTaxCertificate } = handleCompliance();
const { fetchAccountHeads } = handleReport();
const { fetchCompanyDefaultRoles } = handleRole();
const { fetchContactProfiles } = handleContact();
const { formatPatientLabel } = useAsyncDropdownHelper();
const { fetchVdsRateList } = handleTdsVds();
const { fetchPaymentStatus } = handlePurchaseAndSales();
const { fetchCompanyInfo } = handleCompany();
const { exportToPdfMushak66 } = printMushak66();

const hasCertificate = (item) => {
    return !!item.certificate_number;
}

const isPendingTab = computed(() => activeTab.value === 'pending');
const isIssuedTab = computed(() => activeTab.value === 'issued');
const selectableRows = computed(() => tableItems.value.filter(item => !hasCertificate(item)));
const selectedCount = computed(() => selectedRows.value.length);
const hasSelection = computed(() => selectedCount.value > 0);
const isAllSelected = computed(() => selectableRows.value.length > 0 && selectableRows.value.every(item => isSelected(item)));

const rowKey = (item) => {
    return item.register_type + '-' + item.id;
}

const isSelected = (item) => {
    return selectedRows.value.some(row => rowKey(row) === rowKey(item));
}

const toggleSelect = (item) => {
    if (hasCertificate(item)) return;
    if (isSelected(item)) {
        selectedRows.value = selectedRows.value.filter(row => rowKey(row) !== rowKey(item));
        return;
    }
    selectedRows.value.push(item);
}

const toggleSelectAll = () => {
    if (isAllSelected.value) {
        const currentKeys = selectableRows.value.map(item => rowKey(item));
        selectedRows.value = selectedRows.value.filter(row => !currentKeys.includes(rowKey(row)));
        return;
    }
    selectableRows.value.forEach(item => {
        if (!isSelected(item)) selectedRows.value.push(item);
    });
}

const onOpenGenerateModal = () => {
    certificateForm.value.date = '';
    generateModal.value.toggleModal();
}

const buildGeneratePayload = () => {
    const purchaseMasterIds = selectedRows.value.filter(row => row.register_type === 'purchase_master').map(row => row.id);
    const paymentMasterIds = selectedRows.value.filter(row => row.register_type === 'payment_master').map(row => row.id);
    return {
        company_id: route.params.companyId,
        type: 'vds_certificate',
        date: certificateForm.value.date,
        purchase_master_ids: purchaseMasterIds,
        payment_master_ids: paymentMasterIds
    };
}

const onSubmitGenerate = async () => {
    if (!certificateForm.value.date) {
        showError('Please select an issue date');
        return;
    }
    generateModal.value.loading = true;
    const res = await generateTaxCertificate(buildGeneratePayload());
    generateModal.value.loading = false;
    if (!res.status) {
        showError(res.message);
        return;
    }
    showSuccess(res.message);
    generateModal.value.toggleModal();
    selectedRows.value = [];
    getMushakList();
}

const deleteCertificateById = async (certificateId) => {
    if (!confirm('Are you sure you want to delete this certificate? It will be removed from all linked bills.')) return false;
    loading.value = true;
    const res = await deleteTaxCertificate(certificateId, `?company_id=${route.params.companyId}`);
    loading.value = false;
    if (!res.status) {
        showError(res.message);
        return false;
    }
    showSuccess(res.message);
    getMushakList();
    return true;
}

const onPrintCertificate = async (item) => {
    loading.value = true;
    const res = await fetchTaxCertificate(item.certificate_id, `?company_id=${route.params.companyId}`);
    if (!res.status) {
        loading.value = false;
        showError(res.message);
        return;
    }
    const companyRes = await fetchCompanyInfo(route.params.companyId);
    loading.value = false;
    if (!companyRes.status) {
        showError(companyRes.message);
        return;
    }
    exportToPdfMushak66(companyRes.data, res.data.certificate, res.data.bills);
}

const onExportCertificate = (item) => {
    let query = `?company_id=${route.params.companyId}`;
    query += '&is_export=1';
    query += '&_token=' + token.value;
    const url = `${process.env.VUE_APP_BASE_URL}/export/compliance/mushak-six-point-six/${item.certificate_id}${query}`;
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.click();
}

const onEditCertificate = async (item) => {
    loading.value = true;
    const res = await fetchTaxCertificate(item.certificate_id, `?company_id=${route.params.companyId}`);
    loading.value = false;
    if (!res.status) {
        showError(res.message);
        return;
    }
    editCertificateId.value = item.certificate_id;
    editCertificate.value = res.data.certificate;
    editBills.value = res.data.bills;
    editForm.value.date = res.data.certificate.date;
    editModal.value.toggleModal();
}

const onSubmitEdit = async () => {
    if (!editForm.value.date) {
        showError('Please select an issue date');
        return;
    }
    editModal.value.loading = true;
    const payload = {
        company_id: route.params.companyId,
        date: editForm.value.date
    };
    const res = await updateTaxCertificate(editCertificateId.value, payload);
    editModal.value.loading = false;
    if (!res.status) {
        showError(res.message);
        return;
    }
    showSuccess(res.message);
    editModal.value.toggleModal();
    getMushakList();
}

const onDeleteFromModal = async () => {
    const deleted = await deleteCertificateById(editCertificateId.value);
    if (deleted) editModal.value.toggleModal();
}

const onClickToGo = () => {
    selectedRows.value = [];
    getMushakList();
}

const switchTab = async (tab) => {
    if (activeTab.value === tab) return;
    activeTab.value = tab;
    selectedRows.value = [];
    let routeQuery = Object.assign({}, route.query, { tab });
    delete routeQuery.page;
    await router.push({ path: route.path, query: routeQuery });
    getMushakList();
}

const onSearchContact = (contact) => {
    singleContact.value = contact
}

const onOpenContactSearchModal = () => {
    store.state.isModalOpenThree = true;
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    getMushakList();
}

const getAccountHeads = async () => {
    let res = await fetchAccountHeads(route.params.companyId);
    if (res.status) {
        accountHeads.value = res.data;
    }
}

const getCompanyRoles = async () => {
    const res = await fetchCompanyDefaultRoles(`?company_id=${route.params.companyId}`);
    if (res.status) {
        companyRoles.value = res.data
    }
}

const getVdsRates = async () => {
    let query = getQuery();
    query += '&with_code=1';
    const res = await fetchVdsRateList(query);
    if (res.status) {
        vdsRateList.value = res.data;
    }
}

const getPaymentStatus = async () => {
    let query = getQuery();
    const res = await fetchPaymentStatus(query);
    if (res.status) {
        paymentStatuses.value = res.data;
    }
}

const getMushakList = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = [];
    const res = await fetchMushakSixPointSix(query);
    if (!res.status) {
        resetPaginationPage(store, route, router)
        loading.value = false
        return
    }
    tableItems.value = res.data.data;
    setPagination(res.data)
    loading.value = false
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    if (singleContact.value) query += '&contact_profile_id=' + singleContact.value.id;
    if (params.value.account_head_id) query += '&account_head_id=' + params.value.account_head_id;
    if (params.value.payment_status) query += '&payment_status=' + params.value.payment_status;
    if (params.value.vds_rate_id) query += '&vds_rate_id=' + params.value.vds_rate_id;
    query += '&certificate_status=' + activeTab.value;
    query += '&offset=' + params.value.offset
    return query;
}

onMounted(() => {
    Promise.all([
        getAccountHeads(),
        getCompanyRoles(),
        getVdsRates(),
        getPaymentStatus()
    ])
})
</script>

<style>
.mushak-six-query-setter .action-btn-setter {
    margin-bottom: 1.5% !important;
}
.custom-table-padding {
    width: 140%
}
.mushak-table-wrap {
    overflow-x: auto;
    min-height: 420px;
}
.dropdown-menu.show {
    z-index: 1055;
}
</style>
